import { render } from "./BtnPlain.vue?vue&type=template&id=136236f6&scoped=true"
const script = {}

import "./BtnPlain.vue?vue&type=style&index=0&id=136236f6&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136236f6"]])

export default __exports__